import React from 'react'
import styled from '@emotion/styled'
import MuiListItemButton from '@mui/material/ListItemButton'

const StyledListItemButton = styled(MuiListItemButton)`
  padding: ${() => '8px 16px 8px 28px'};
  &.Mui-selected {
    color: #0057b2 !important;
    background-color: unset !important;
  }
`

const ListItemButton = (props: any) => {
  return <StyledListItemButton {...props} />
}

export default ListItemButton
